export const detectMobileDevice = (): boolean | null => {
  if (!navigator) return null;
  if ((navigator as any).userAgentData) return (navigator as any).userAgentData.mobile;
  return /Android|webOS|iPhone|iPad/i.test(navigator.userAgent);
};
